import { Extension } from "state/extensions/state";

export const filterConfiguredExtensions = (extensions: Extension[]): Extension[] => {
    return extensions.filter((extension)=>{
        return extension.extension?.numbers?.length;
    })
}